module.exports = __webpack_public_path__ + "assets/img/headerCallIco.84c6ff3e.svg";